import AccrualsHistory from './AccrualsHistory.vue'

export default AccrualsHistory
